<template>
  <div class="mine-publish-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="我的发布" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="general-tab-part favorite-tab" style="display:flex;justify-content: space-between;">
      <div class="tab-item" @click = "change('5')" :class="{'selected':type == '5'}">全屋记</div>
      <!-- <div class="tab-item" @click = "change('2')" :class="{'selected':type == '2'}">店铺</div> -->
      <div class="tab-item" @click = "change('3')" :class="{'selected':type == '3'}">文章</div>
      <div class="tab-item" @click = "change('4')" :class="{'selected':type == '4'}">问答</div>
      <div class="tab-item" @click = "change('1')" :class="{'selected':type == '1'}">图片</div>
    </div>
    <div class="qa-section" >
      <div v-if="questionList.length>0" class="qa-list">
        <div class="question-item general-box-shadow" v-for="question in questionList">
          <div class="question-subject" @click="toQuestionDetail(question.id)">{{question.subject}}</div>
          <div class="question-image-list" @click="toQuestionDetail(question.id)" v-if="question.imageArray && question.imageArray.length>0">
            <img v-for="img in question.imageArray" :src="imgUrl + img"/>
          </div>
          <div class="question-bottom">
            <div class="right" @click="toQuestionDetail(question.id)">
              <div>回答&nbsp;{{question.answerCount || 0}}</div>
              <div class="create-time">{{question.createTime| prettifyTime}}</div>
            </div>
          </div>
          <div class="bottom-btn">
            <div v-if="question.status == '1'" class="qa-status status-publish">{{question.status | qaStatusConvert}}</div>
            <div v-if="question.status == '3'" class="qa-status status-reject">{{question.status | qaStatusConvert}}</div>
            <div v-if="question.status == '2'" class="qa-status status-apply">{{question.status | qaStatusConvert}}</div>
            <div class="btn-right">
              <div v-if="question.status == '3'" class="qa-edit-btn" @click="editQa(question.id)">编辑</div>
              <div class="qa-del-btn" @click="preDelQa(question.id)">删除</div>
            </div>
          </div>
        </div>
      </div>
      <div class="black-page" v-if="questionList.length==0">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">您还未发布过内容哦</div>
      </div>
    </div>
    <div v-if="delQqModal" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelDel()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">确定要删除该问题吗？</div>
      <div class="agree-btn" @click="confirmDelQa()">狠心删除</div>
    </div>
    <div v-if="delQqModal" class="pay-box"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl} from "../../config";
  import questionService from '../../service/qa/QuestionService'

  export default {
    name: 'MinePublish',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        tabSelected:'0',
        activityList:[],
        articleList:[],
        questionList:[],
        pageNo:1,
        isWechatBrowser:this.$verfyBrowserType(),
        delQqModal:false,
        preDelQaId:'',
        type:'5',
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.loadQuestionList();
    },
    methods: {
      change(type){
        this.type = type;
        this.loadFavoriteList();
      },
      async loadQuestionList(){
        if(this.pageNo == 1){
          this.questionList = [];
        }
        let {code,msg,data} = await questionService.publishList(this.pageNo);
        if(code == '0'){
          for(let qu of data){
            if(qu.subject.length>18){
              qu.subject = qu.subject.substring(0,18)+'...'
            }
            this.questionList.push(qu)
          }
        }else {
          Toast(msg);
        }
      },
      preDelQa(id){
        this.delQqModal = true;
        this.preDelQaId = id;
      },
      cancelDel(){
        this.delQqModal = false;
      },
      editQa(questionId){
        this.$router.push({name: 'QaEdit',query:{questionId}});
      },
      async confirmDelQa(){
        let {code,msg,data} = await questionService.remove(this.preDelQaId);
        if(code == '0'){
          Toast('问题已删除!');
          this.loadQuestionList();
        }else {
          Toast('问题删除失败，请稍后重新!');
        }
        this.delQqModal = false;
      },
      toQuestionDetail(questionId){
        this.$router.push({name: 'QaDetail',query:{questionId}});
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .favorite-tab{
    font-size: 0.32rem;
    .selected{
      font-size: 0.36rem;
    }
  }
  .mine-publish-page{
    padding-top: 0.32rem;
    background: white;
    padding-bottom: 0.5rem;
    .question-bottom{
      padding-bottom: 0.2rem;
      margin-bottom: 0.2rem;
      border-bottom: solid 1px #e0dedc;
    }
    .bottom-btn{
      display: flex;
      justify-content: space-between;
      .qa-status{
        height: 0.5rem;
        line-height: 0.5rem;
        padding: 0 0.2rem;
        text-align: center;
        color: white;
        border-radius: 0.25rem;
        font-size: 0.28rem;
      }
      .status-publish{
        background-color: #70c285;
      }
      .status-reject{
        background-color: #d54a33;
      }
      .status-apply{
        background-color: #feac00;
      }
    }
    .qa-del-btn{
      width: 0.8rem;
      height: 0.4rem;
      margin-left: 0.2rem;
      font-size: 0.24rem;
      color: #ffffff;
      line-height: 0.42rem;
      text-align: center;
      border-radius: 20px;
      background-color: #d54a33;
    }
    .qa-edit-btn{
      width: 0.8rem;
      height: 0.4rem;
      font-size: 0.24rem;
      color: #feac00;
      line-height: 0.42rem;
      text-align: center;
      border-radius: 20px;
      background-color: #fff7e5;
    }
    .btn-right{
      display: flex;
      align-items: center;
    }
  }
</style>
